import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Play, Pause, ShoppingBag } from 'lucide-react';
import { toast } from 'sonner';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const Beats = () => {
  const [beats, setBeats] = useState([]);
  const [playing, setPlaying] = useState(null); 
  const [audio, setAudio] = useState(null);

  useEffect(() => {
    const fetchBeats = async () => {
      try {
        const res = await axios.get(`${BACKEND_URL}/api/beats`);
        setBeats(res.data);
      } catch (e) {
        console.error(e);
      }
    };
    fetchBeats();
  }, []);

  const handlePlay = async (beat) => {
    try {
      if (playing === beat.id) {
        audio.pause();
        setPlaying(null);
      } else {
        if (audio) {
            audio.pause();
            audio.currentTime = 0; // Reset previous
        }
        
        // Robust Player
        const newAudio = new Audio();
        newAudio.src = beat.audio_url;
        newAudio.crossOrigin = "anonymous"; // Help with Drive CORS
        newAudio.preload = "auto";
        
        // Feedback loop
        const playPromise = newAudio.play();
        
        if (playPromise !== undefined) {
            playPromise
                .then(() => {
                    // Play started
                    setAudio(newAudio);
                    setPlaying(beat.id);
                })
                .catch(error => {
                    console.error("Playback failed:", error);
                    toast.error("Impossible de lire ce fichier audio (Format ou Accès refusé)");
                });
        }
        
        newAudio.onended = () => setPlaying(null);
      }
    } catch (e) {
        console.error("Audio error", e);
    }
  };

  const handleBuy = async (beat) => {
    try {
        const currentUrl = window.location.origin;
        
        // Check if user is logged in to attach email
        const storedUser = localStorage.getItem('user');
        const user = storedUser ? JSON.parse(storedUser) : null;
        
        const metadata = {
            type: 'beat',
            beat_id: beat.id,
            title: beat.title
        };

        if (user) {
            metadata.client_email = user.email;
        }

        const res = await axios.post(`${BACKEND_URL}/api/payments/checkout/session`, {
            amount: beat.price,
            currency: 'eur',
            success_url: `${currentUrl}/payment-success?session_id={CHECKOUT_SESSION_ID}`,
            cancel_url: `${currentUrl}/beats`,
            metadata: metadata
        });
        if (res.data.url) {
            window.location.href = res.data.url;
        }
    } catch (e) {
        toast.error("Erreur de paiement");
    }
  };

  return (
    <div className="pt-24 pb-20 px-4 min-h-screen">
      <div className="max-w-7xl mx-auto">
        <h1 className="text-4xl md:text-5xl font-bold mb-4 text-center bg-clip-text text-transparent bg-gradient-to-r from-purple-400 to-blue-400">Catalogue d'Instrumentales</h1>
        <p className="text-gray-400 text-center mb-12 text-lg">Des productions exclusives pour vos projets.</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {beats.map(beat => (
            <div key={beat.id} className="bg-neutral-900 border border-white/10 rounded-2xl overflow-hidden group hover:border-purple-500/50 transition-all">
              <div className="relative aspect-square">
                <img src={beat.cover_image} alt={beat.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110" />
                <div className="absolute inset-0 bg-black/40 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity backdrop-blur-sm">
                  <button 
                    onClick={() => handlePlay(beat)}
                    className="w-16 h-16 bg-purple-600 rounded-full flex items-center justify-center hover:bg-purple-500 transition-colors shadow-lg"
                  >
                    {playing === beat.id ? <Pause fill="white" /> : <Play fill="white" className="ml-1" />}
                  </button>
                </div>
              </div>
              
              <div className="p-6">
                <div className="flex justify-between items-start mb-2">
                   <div>
                      <h3 className="text-xl font-bold">{beat.title}</h3>
                      <p className="text-sm text-gray-400">{beat.bpm} BPM • {beat.key}</p>
                   </div>
                   <div className="text-xl font-bold text-purple-400">{beat.price}€</div>
                </div>
                
                <div className="flex gap-2 mb-6">
                    {beat.tags.map(tag => (
                        <span key={tag} className="text-xs px-2 py-1 bg-white/5 rounded-md text-gray-300">
                            {tag}
                        </span>
                    ))}
                </div>

                <button 
                    onClick={() => handleBuy(beat)}
                    className="w-full py-3 bg-white text-black font-bold rounded-xl hover:bg-gray-200 transition-colors flex items-center justify-center gap-2"
                >
                    <ShoppingBag className="w-4 h-4" /> Acheter la licence
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Beats;
